import { OmsSetupPath as OmsSetupPathEnum } from "@redotech/congo-enums/oms-setup-path";
import { OmsFlagKey } from "@redotech/feature-flags-keys-oms/keys";
import { OMS_TRIAL_AUTO_RELOAD } from "@redotech/merchant-sdk/rpc/schema/unified-onboarding/oms-trial";
import type { SessionContext, UnifiedOnboardingProductId } from "../../types";

export const OMS_PRODUCT_ID: UnifiedOnboardingProductId = "oms";

export const OMS_LABEL = "Shipping & Fulfillment";

/** The same flag that gates the older setup-app OMS flow, so both open together. */
export const OMS_GATE_FLAG = OmsFlagKey.MERCHANT_ONBOARDING_OMS;

export const OMS_BILLING_PAGE_ID = "oms.billing";
export const OMS_SALES_CHANNELS_PAGE_ID = "oms.sales_channels";
/** Business name and ship-from address, asked only when no channel supplied them. */
export const OMS_BUSINESS_PAGE_ID = "oms.business";
/** Hosts the `oms.book_onboarding` step: the expert / self-serve choice plus the scheduler. */
export const OMS_SETUP_PATH_PAGE_ID = "oms.setup_path";

/** Admin-overridable booking link, shared with the setup app's shipping flow. */
export const OMS_BOOKING_DESTINATION_ID = "shipping-fulfillment";

export type OmsSetupPath = `${OmsSetupPathEnum}`;
export const OMS_SETUP_PATHS: readonly OmsSetupPath[] =
  Object.values(OmsSetupPathEnum);

/** Undefined until chosen; a skipped choice falls through to self-serve. */
export function readOmsSetupPath(
  ctx: SessionContext,
): OmsSetupPath | undefined {
  const value = ctx.stepValues["oms.book_onboarding"]?.path;
  return OMS_SETUP_PATHS.find((path) => path === value);
}

export function wantsExpertSetup(ctx: SessionContext): boolean {
  return readOmsSetupPath(ctx) === "expert";
}

/** The channels step mirrors the team's live connections into this value. */
export function hasConnectedSalesChannel(ctx: SessionContext): boolean {
  return ctx.stepValues["oms.sales_channels"]?.connected === true;
}

export const OMS_BILLING_READY_TOAST = "Billing is set up.";

export const OMS_BILLING_AUTHORIZE_LABEL = `I authorize Redo to charge the card on file for shipping labels, adding $${OMS_TRIAL_AUTO_RELOAD.amountUsd} to my label balance whenever it drops below $${OMS_TRIAL_AUTO_RELOAD.thresholdUsd}.`;

export const OMS_BILLING_SUMMARY = {
  productName: OMS_LABEL,
  pricingSummary: `Labels draw from a prepaid balance. Your card tops it up automatically, $${OMS_TRIAL_AUTO_RELOAD.amountUsd} at a time, whenever it drops below $${OMS_TRIAL_AUTO_RELOAD.thresholdUsd}. No monthly fee during your trial.`,
} as const;
